export class OrderItemAskForOrderIdError extends Error {

}
